var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`formulate-input-element formulate-input-element--${_vm.context.class}`,attrs:{"data-type":_vm.context.type}},[_c('div',{class:_vm.contentClass,domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }